import type { AdminUserAccountStatus, AdminUserRow } from './adminUserRow';

function pickString(obj: Record<string, unknown>, keys: string[]): string | undefined {
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === 'string' && v.length > 0) return v;
  }
  return undefined;
}

function pickBool(obj: Record<string, unknown>, keys: string[], fallback = true): boolean {
  for (const k of keys) {
    const v = obj[k];
    if (typeof v === 'boolean') return v;
  }
  return fallback;
}

/**
 * Map DTO user admin (không cố định schema) → hàng hiển thị bảng.
 * Cần BE xác nhận tên field chuẩn để thu hẹp danh sách alias.
 */
export function mapAdminUserDtoToRow(raw: Record<string, unknown>): AdminUserRow {
  const id = pickString(raw, ['id', 'user_id']) ?? '';
  const username = pickString(raw, ['username', 'user_name', 'login', 'user_login']);
  const name = pickString(raw, ['display_name', 'full_name', 'name']) ?? username ?? '—';
  const email = pickString(raw, ['email']) ?? '—';
  const role = pickString(raw, ['role_slug', 'role', 'role_name']) ?? '—';
  const deptRaw = raw.department;
  const departmentFromNested =
    typeof deptRaw === 'string'
      ? deptRaw
      : deptRaw && typeof deptRaw === 'object' && deptRaw !== null
        ? pickString(deptRaw as Record<string, unknown>, ['name', 'code'])
        : undefined;
  const department =
    departmentFromNested ?? pickString(raw, ['department_name', 'department_code']) ?? '—';
  const phone = pickString(raw, ['phone', 'phone_number', 'mobile']) ?? '—';
  const accountStatusRaw = pickString(raw, ['account_status']);
  const accountStatus: AdminUserAccountStatus | undefined =
    accountStatusRaw === 'active' ||
    accountStatusRaw === 'locked' ||
    accountStatusRaw === 'inactive'
      ? accountStatusRaw
      : undefined;
  const active = accountStatus
    ? accountStatus === 'active'
    : pickBool(raw, ['active', 'is_active'], true);
  const lastLogin = pickString(raw, ['last_login_at', 'last_login', 'lastLogin']) ?? undefined;
  const createdAt = pickString(raw, ['created_at', 'createdAt', 'create_date']) ?? undefined;

  return {
    id,
    username,
    name,
    email,
    role,
    department,
    phone,
    active,
    accountStatus,
    lastLogin,
    createdAt,
    raw,
  };
}
